define.alias("checkout/components/seamless-checkout/trial-plans-modal", "settings/components/seamless-checkout/trial-plans-modal");